import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { NOTIFICATION_TYPE } from '../../../../../constants/common'
import { useDate, useDateLimits, useScreen } from '../../../../../hooks'
import { getQaSelector } from '../../../../../utils/common'
import { Checkbox, CHECKBOX_SIZE } from '../../../../Checkbox'
import { DatePicker } from '../../../../DateTime'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
} from '../../../../Formik'
import { NotificationInline } from '../../../../Notification'
import Text from '../../../../Text'
import {
  QA_NAME_VIEWING_FORM_REPEAT,
  QA_NAME_VIEWING_FORM_SERIES_WARNING,
  VIEWING_FORM_FIELD_NAME,
} from '../../RentalPortalViewingFormModal.constants'
import { getViewingFormSeriesStarts } from '../../RentalPortalViewingFormModal.utils'
import { getViewingFormFieldErrorProps } from '../../RentalPortalViewingFormModal.utils.validation'
import { getHasViewingFormSeriesWarning } from '../RentalPortalViewingFormModalFields.utils'

function ViewingFormRepeatFields() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const { maxDate } = useDateLimits()

  const date = useDate()

  const { values } = useFormikContext()

  const seriesCount = getViewingFormSeriesStarts(values).length

  return (
    <Fragment>
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={t('RentalPortal.ViewingFormRepeatLabelKey')}
        name={VIEWING_FORM_FIELD_NAME.withRepeat}
        qaName={QA_NAME_VIEWING_FORM_REPEAT}
        size={CHECKBOX_SIZE.small}
      />
      {values[VIEWING_FORM_FIELD_NAME.withRepeat] ? (
        <FormikField
          Component={DatePicker}
          borderless={!isMobileScreenSize}
          fieldComponentProps={{
            label: `${t('RentalPortal.ViewingFormRepeatUntilLabelKey')}:`,
            required: true,
            shouldAdaptToMobileScreen: true,
          }}
          getErrorProps={getViewingFormFieldErrorProps}
          maxValue={maxDate}
          minValue={date}
          name={VIEWING_FORM_FIELD_NAME.repeatUntil}
          placeholder={t('RentalPortal.ListingFormDatePlaceholderKey')}
        />
      ) : null}
      {seriesCount > 1 ? (
        <Text isSecondary>
          {t('RentalPortal.ViewingFormSeriesPreviewKey', {
            count: seriesCount,
          })}
        </Text>
      ) : null}
      {getHasViewingFormSeriesWarning(seriesCount) ? (
        <NotificationInline
          {...getQaSelector({ value: QA_NAME_VIEWING_FORM_SERIES_WARNING })}
          text={t('RentalPortal.ViewingFormSeriesWarningKey', {
            count: seriesCount,
          })}
          type={NOTIFICATION_TYPE.warning}
        />
      ) : null}
    </Fragment>
  )
}

export default ViewingFormRepeatFields
